import { render, staticRenderFns } from "./directComplete.vue?vue&type=template&id=180f747f&"
import script from "./directComplete.vue?vue&type=script&lang=js&"
export * from "./directComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports